import React from 'react';
import { FormattedMessage } from 'react-intl';

import { goToUrl } from 'helpers/utils';
import routes from 'routes';
import FormActionButtons from 'components/FormActionButtons/FormActionButtons';
import { GenericTitle, TitleMargin } from 'components/GenericTitle/GenericTitle';
import GenericTitleSummary from 'components/GenericTitleSummary/GenericTitleSummary';

interface Props {
  text: string;
}

const InvitationErrorMessage = ({ text }: Props) => (
  <div>
    <GenericTitle marginBottom={TitleMargin.Sm}>
      <FormattedMessage tagName="span" id="shared.sorry" />
    </GenericTitle>

    <GenericTitleSummary>
      <FormattedMessage id={text} />
    </GenericTitleSummary>

    <FormActionButtons
      submitBtnContent={<FormattedMessage id="nav.signUp" />}
      labelBtnContent={<FormattedMessage id="shared.modal.contactUs" />}
      onSubmitBtnClick={() => goToUrl(routes.signUp.path())}
      onLabelBtnClick={() => goToUrl(routes.root.path())}
    />
  </div>
);

export default InvitationErrorMessage;
